/*
 * @Author: ken yang
 * @Date: 2022-08-30 11:14:14
 * @LastEditTime: 2023-05-31 18:00:08
 * @LastEditors: ken yang
 * @Description:
 * @FilePath: /uexch_pc/src/store/config.js
 */
import { defineStore } from 'pinia'
import { LANGCN, LANGEN, LANGTW, LANGJA } from '@/utils/constant'

const useConfigStore = defineStore('configStore', {
  state: () => {
    const winLocale = getUrlQuery().locale
    const browserLang = borwserLang()
    return {
      locale: winLocale || localStorage.getItem('locale') || browserLang,
      languageMap: [
        {
          label: '简体中文',
          value: LANGCN,
        },
        {
          label: 'English',
          value: LANGEN,
        },
        {
          label: '繁體中文',
          value: LANGTW,
        },
        {
          label: '日本語',
          value: LANGJA,
        },
      ]
    }
  },
  getters: {
    languageName: (state) => state.languageMap.find(item => item.value == state.locale)?.label,
  },
  actions: {
    async setLanguage (value) {
      this.locale = value
      $t.changeLange(value)
    },
  },
  init () {
    this.$subscribe((mutation, state) => {
      localStorage.locale = state.locale
    })
  },
})

export default useConfigStore
